import { inSSRContext } from '@/lego/utils/render/ssr';
import resolveConfig from 'tailwindcss/resolveConfig';
// TODO: Algún alias para el ROOT.
import tailwindConfig from '../../../../../tailwind.config.js';

const config = resolveConfig(tailwindConfig);

export function getScreens() {
  const screens = {};

  Object.entries(config?.theme?.screens)
    .filter(([key, value]) => typeof value === 'string')
    .forEach(([key, value]) => (screens[key] = parseInt(value.replace('px', ''))));

  return screens;
}

export function getCurrentScreen(screens = null) {
  const currentScreenWidth = getScreenSize().width;
  let currentScreen = 'xs';

  Object.entries(screens || getScreens()).forEach(([key, value]) => {
    if (currentScreenWidth >= value) {
      currentScreen = key;
    }
  });

  return currentScreen;
}

export function getTouchedScreen(breakpoints) {
  const breakpointSizes = {};
  const screens = getScreens();

  Object.entries(breakpoints).forEach(([key, value]) => {
    if (screens[key]) {
      breakpointSizes[key] = screens[key];
    }
  });

  return getCurrentScreen(breakpointSizes);
}

export function getScreenSize() {
  if (inSSRContext()) {
    return {
      width: 1920,
      height: 1080,
    };
  }

  return {
    width: window.innerWidth,
    height: window.innerHeight,
  };
}
